import { OutBound } from 'core/brand/Brand';
import IconWithTooltip from 'components/IconWithTooltip/IconWithTooltip';
import styles from './Outbound.module.scss';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
import { useState, useEffect } from 'react';
import { CollapseSection } from 'components/Rsuite/Section';
import { Input, Toggle, Form, RadioGroup, Radio, Modal } from 'rsuite';
import { RsSelect } from 'components/Rsuite/Select';
import fbLogo from 'assets/outbound/fb.svg';
import messageCircle from 'assets/outbound/messageCircle.svg';
import messager from 'assets/outbound/messager.svg';
import plus from 'assets/outbound/plus.svg';
import search from 'assets/outbound/search.svg';
import thumbsUp from 'assets/outbound/thumbsUp.svg';
import vector from 'assets/outbound/Vector.svg';
import vectorCicle from 'assets/outbound/vectorCicle.svg';
import vectorEarth from 'assets/outbound/vectorEarth.svg';
import clothesImage from 'assets/outboundKeyword/T-Shirt.svg';
import FacebookLogo from 'assets/outboundKeyword/facebook_logo.svg';
import facebookLogo from 'assets/outboundKeyword/facebook_logo.svg';
import InstagramLogo from 'assets/outboundKeyword/instagram_logo.svg';
import instagramLogo from 'assets/outboundKeyword/instagram_logo.svg';
import GoogleLogo from 'assets/outboundKeyword/google_logo.svg';
import googleLogo from 'assets/outboundKeyword/google_small_logo.svg';
import OutboundKeywordBanner from 'assets/outboundKeyword/network_banner.svg';
import externalLink from 'assets/external-link.svg';
import { Goal, OutboundInfo } from '../../../Hooks/useKeywordForm';
import maximize from 'assets/maximize.svg';
import minimize from 'assets/minimize.svg';
import InfoOutlineIcon from '@rsuite/icons/InfoOutline';
import TreeSelect from 'components/TreeSelect/TreeSelect';
import { RestfulCampaignWebService, TreeNode } from 'ws/OutboundMetaWebService';
import { TreeDataManager } from 'core/treeSelect/TreeDataManger';
import Skeleton from 'react-loading-skeleton';
import { RadioCell } from 'components/Rsuite/Radio';
import { ActionType } from 'core/rtbCampaign/singlePage/common';
import { RsConfirmationModalTrigger } from 'components/Rsuite/Modal';
import { Info } from 'react-feather';
import { useCampaignStore } from 'store/campaignStore';
interface Iprops {
  outsideMetaPermission: boolean;
  outboundBrandOptions?: OutBound[];
  enAbledOutboundSection: boolean;
  enableOutbound: boolean;
  defaultForm: any;
  outboundHiteText: string;
  outboundInfo: OutboundInfo;
  brandNoMessage: string;
  goalMessage: string;
  adContentMessage: string;
  webBrandNo: string;
  selectPattern: string;
  outBoundMetaLoading: boolean;
  changOutbound: (selectedOption: any) => void;
  handleChangeToggle: (checked: boolean) => void;
  changeAdContent: (e: string) => void;
  handleSegmentChange: (segment: string[]) => void;
  handleGoalChange: (goal: Goal) => void;
  limitedOutbound: () => boolean;
}
const initialOutBoundInfo: OutboundInfo = {
  brandNo: '',
  brandName: '',
  name: '',
  logoUrl: '',
  adContent: '',
  segment: [],
  goal: '',
};

export const OutBound_default_AdContent = `momo 全站限時優惠\n熱門商品特價中\n立即加入購物車！`;
const restfulService = new RestfulCampaignWebService();

const Outbound: React.FC<Iprops> = ({
  outsideMetaPermission,
  outboundBrandOptions = [],
  brandNoMessage,
  goalMessage,
  adContentMessage,
  changeAdContent,
  outboundInfo = initialOutBoundInfo,
  enAbledOutboundSection,
  enableOutbound,
  handleChangeToggle,
  outboundHiteText,
  changOutbound,
  defaultForm,
  webBrandNo,
  selectPattern,
  outBoundMetaLoading,
  handleSegmentChange,
  handleGoalChange,
  limitedOutbound,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isPreviewExpanded, setIsPreviewExpanded] = useState(true);
  const [treeData, setTreeData] = useState<TreeNode[]>([]);
  const [loading, setLoading] = useState(false);
  const treeDataManager = new TreeDataManager(restfulService, setLoading);
  const { actionType } = useCampaignStore();

  // 修改站外聯播網主要文字
  const changeOutsideText = (e: string) => {
    // console.log(e)
    setIsExpanded(false);
    changeAdContent(e);
  };

  // 客製 "Meta 廣告投放帳號" 下拉選單的內容
  const renderMenuItem = (label, item) => {
    return (
      <section className='flex items-center gap-2'>
        <img
          src={item?.logoUrl}
          width={40}
          height={40}
          alt=''
          className='rounded-full'
        />
        {label}
        {!item.available && (
          <span className='text-red-500'>
            該品牌下您所選擇的商品不足2品，無法投遞 Meta 廣告
          </span>
        )}
      </section>
    );
  };

  const renderValue = (_, item) => {
    if (!item) return <div className='text-[#808080]'>請選擇</div>;
    return (
      <section className='flex items-center gap-2'>
        {item?.logoUrl && (
          <img
            src={item?.logoUrl}
            width={30}
            height={30}
            alt=''
            className='rounded-full'
          />
        )}

        <span className='mb-[2px]'>{item?.brandName}</span>
      </section>
    );
  };

  const disabledItemValues =
    outboundBrandOptions?.reduce((prev, curr) => {
      if (!curr.available) prev.push(curr.value as never);
      return prev;
    }, []) || [];

  // 顯示更多的文字
  const renderText = () => {
    if (isExpanded) {
      return outboundInfo.adContent;
    }
    const lines = outboundInfo.adContent
      ? outboundInfo.adContent.split('\n')
      : [];
    if (lines.length > 3) {
      return lines.slice(0, 3).join('\n');
    }
    return outboundInfo.adContent;
  };

  // 手機模擬-顯示更多是否展開的參數
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const togglePreviewExpand = () => {
    setIsPreviewExpanded(!isPreviewExpanded);
  };

  useEffect(() => {
    const fetchTreeData = async () => {
      setLoading(true);
      try {
        const rootNode = await treeDataManager.getDefaultRootNode();
        setTreeData(rootNode);
      } catch (error) {
        console.error('Failed to fetch tree data:', error);
      } finally {
        setLoading(false);
      }
    };
    if (outsideMetaPermission) fetchTreeData();
  }, [outsideMetaPermission]);

  return (
    <CollapseSection
      title='momo聯播網'
      className='h-[1160px] max-h-[1160px] overflow-hidden p-0 transition-all duration-300'
      customRight={
        <section className='mt-[3px] flex items-center'>
          <RsConfirmationModalTrigger
            renderModalTrigger={(openModal) => (
              <Toggle
                loading={outBoundMetaLoading}
                className='customToggle mr-2'
                // className={styles.customToggle}
                checked={enableOutbound}
                disabled={
                  limitedOutbound() ||
                  !enAbledOutboundSection ||
                  defaultForm?.basic?.state === 4 ||
                  defaultForm?.basic?.state === 2
                }
                onChange={
                  actionType === ActionType.EDIT &&
                  defaultForm?.basic?.outboundInfo?.brandNo?.length > 0 &&
                  enableOutbound
                    ? openModal
                    : handleChangeToggle
                }
              />
            )}
            message={
              <span className='text-[16px]'>
                關閉momo聯播網後,將不得再次開啟,您確認要關閉嗎?
              </span>
            }
            onConfirm={(closeModal) => {
              handleChangeToggle(!enableOutbound);
              closeModal();
            }}
          />
          {!outBoundMetaLoading && (
            <span className='mt-[2px] text-[15px] font-bold text-red-500'>
              {outboundHiteText}
            </span>
          )}
          {actionType === ActionType.EDIT &&
            defaultForm?.basic?.outboundInfo?.brandNo?.length > 0 &&
            limitedOutbound() && (
              <span className='inline-flex items-center text-[#5950B5]'>
                <Info width={16} height={16} className='mr-2 text-[#5950B5]' />
                本活動無法再次開啟momo聯播網,若有需要請重新建立廣告活動
              </span>
            )}
        </section>
      }
    >
      <div className='mb-[30px] flex h-[217px] items-center justify-between gap-[80px] bg-[#F4F3FF] px-[112px] py-6'>
        <div className='mr-3 w-[520px]'>
          <span>
            <img src={FacebookLogo} className='mr-6' />
            <img src={InstagramLogo} className='mr-6' />
            <img src={GoogleLogo} />
          </span>
          <p className='mt-3 text-sm'>
            將您的廣告投放至
            momo站外聯播網，解鎖更多優質版位，全面觸及潛力轉換用戶，提升曝光覆蓋率與投放成效。
          </p>
        </div>
        <div>
          <img src={OutboundKeywordBanner} className='relative -bottom-2' />
        </div>
      </div>
      <div
        className={`${styles.component} ${!enableOutbound && styles.enableOutboundSection}`}
      >
        <div className={styles.session_left}>
          <fieldset>
            <legend>
              <span>Meta 廣告投放帳號</span>
              <IconWithTooltip
                icon={faQuestionCircle}
                placement='bottom-start'
                tooltipProps={{
                  id: 'tags-hint',
                  tooltip:
                    '請選擇一個品牌作為 Meta 投放帳號，系統將使用您在momo的品牌頭像與資訊，並於帳號名稱加上「- momo購物網」',
                }}
              />
            </legend>
            <span className={styles.hint}>
              請選擇品牌作為投放帳號, Meta 廣告僅投放該品牌下的商品,
              站內關鍵字廣告則投放您所選的全部商品。
            </span>

            <Form.Group>
              {defaultForm?.basic?.outboundInfo?.brandName ? (
                <div className='mt-[10px] flex h-[42px] w-[560px] items-center gap-[8px] rounded border border-solid border-[#D9D9D9] bg-[#D9D9D9] p-[7px] font-bold text-[#404040]'>
                  <img
                    src={defaultForm?.basic?.outboundInfo?.logoUrl}
                    width={30}
                    height={30}
                    alt=''
                    className='rounded-full'
                  />

                  {defaultForm?.basic?.outboundInfo?.brandName}
                </div>
              ) : (
                <RsSelect
                  className='mt-[10px] w-[640px]'
                  data={outboundBrandOptions}
                  // 只要 defaultForm 已有選品, 就不可再更改站外品牌
                  disabled={
                    defaultForm?.basic?.outboundInfo?.brandNo?.length > 0 ||
                    (selectPattern === 'AUTO' && webBrandNo?.length > 0)
                  }
                  disabledItemValues={disabledItemValues}
                  value={outboundInfo.brandNo}
                  onChange={changOutbound}
                  cleanable={false}
                  renderMenuItem={renderMenuItem}
                  renderValue={renderValue}
                />
              )}

              <Form.ErrorMessage
                show={brandNoMessage !== undefined}
                placement='topStart'
              >
                {brandNoMessage}
              </Form.ErrorMessage>
            </Form.Group>

            <span className={styles.error_adContent} />
          </fieldset>
          <fieldset>
            <legend>
              <span>投放目標</span>
            </legend>
            <div className={`${styles.hint}`}>
              <span>
                請依行銷目的選擇，「導流」提升商品頁點擊量，「轉換」為您爭取更多潛在銷量
              </span>
              <Form.Group className='mt-[10px]'>
                <RadioGroup
                  value={outboundInfo.goal}
                  onChange={(value) => handleGoalChange(value as Goal)}
                >
                  <div className='flex items-center pt-[5px]'>
                    <RadioCell
                      value={Goal.LINK_CLICKS}
                      label='導流'
                      disabled={!!defaultForm?.basic?.outboundInfo?.goal}
                    />
                    <RadioCell
                      value={Goal.CONVERSIONS}
                      label='轉換'
                      disabled={!!defaultForm?.basic?.outboundInfo?.goal}
                    />
                  </div>
                </RadioGroup>
                <Form.ErrorMessage
                  show={goalMessage !== undefined}
                  placement='topStart'
                >
                  {goalMessage}
                </Form.ErrorMessage>
              </Form.Group>
            </div>
          </fieldset>
          <fieldset>
            <legend>
              <span>品類受眾</span>
              <div className={`${styles.hint}`}>
                <span>
                  基於 momo 受眾互動與購買資料，輔以 AI
                  智能擴量，找到該品類的潛力購買人群。
                </span>
              </div>
              {loading ? (
                <Skeleton width={560} height={40} />
              ) : (
                <TreeSelect
                  treeData={treeData}
                  value={outboundInfo.segment}
                  onChange={(ids) => {
                    handleSegmentChange(ids);
                  }}
                  placeholder={loading ? '載入中...' : '請選擇'}
                  loading={loading}
                  allowClear
                  disabled={loading}
                  autoCheckChildren={true}
                  showSelectAll={false}
                  width={560}
                />
              )}
            </legend>
          </fieldset>
          <fieldset className={styles.adContent}>
            <legend>
              <span>Meta 廣告主要文字</span>
              <IconWithTooltip
                icon={faQuestionCircle}
                placement='bottom-start'
                tooltipProps={{
                  id: 'tags-hint',
                  tooltip:
                    '建議 1-3 行文字，勿超過 80 個字元，請勿輸入任何網址',
                }}
              />
            </legend>
            <Form.Group>
              <Input
                as='textarea'
                rows={3}
                className='mb-[30px] !w-full'
                placeholder='請輸入 Meta 廣告主要文字'
                value={outboundInfo.adContent}
                onChange={changeOutsideText}
              />
              <Form.ErrorMessage
                show={adContentMessage !== undefined}
                placement='topStart'
              >
                {adContentMessage}
              </Form.ErrorMessage>
            </Form.Group>
            <ul className={styles.hint}>
              <li className='font-bold text-[#413993]'>
                在「日預算」模式下開啟聯播網時，根據系統優化廣告過程，每日花費可能超過日預算上限設定，若超過訂單總預算，超花金額將於訂單結算後退回您的儲值額度。
              </li>
              <li>
                請確保廣告內容符合相關法規並不侵害第三方權益，若有問題，您需自行承擔相關法律責任與賠償
              </li>
              <li>
                建立廣告即表示您同意系統使用您於 momo 設定的品牌帳號名稱與 Logo
                進行Meta廣告投遞
              </li>
              <li>此功能不保證達成投入產出比 (ROAS) 或任何成效指標</li>
            </ul>
          </fieldset>
        </div>

        <div>
          {/* <div className={styles.session_right}>
            <div className={styles.adPreview}>
              <FontAwesomeIcon icon={faFacebook} />
              廣告預覽
            </div>
            <div className={styles.container}>
              <div className={styles.phone}>
                <div className={styles.header}>
                  <img src={fbLogo} width={88} height={37} alt='' />
                  <div className={styles.tools}>
                    <img src={plus} width={26} height={26} alt='' />
                    <img src={search} width={26} height={26} alt='' />
                    <img src={messager} width={26} height={26} alt='' />
                  </div>
                </div>
                <div className={styles.header_title_container}>
                  <div className={styles.header_title_logo}>
                    {outboundInfo.logoUrl && (
                      <img
                        src={outboundInfo.logoUrl}
                        id='header-title-logo'
                        width={20}
                        height={20}
                        alt='typescript'
                      />
                    )}
                  </div>
                  <div className={styles.header_title_body}>
                    <span
                      id='header-title-brandName'
                      className={styles.header_title_brandName}
                    >
                      {outboundInfo.name
                        ? outboundInfo.name
                        : '品牌名稱 - momo購物網'}
                    </span>
                    <div>
                      <span className={styles.header_title_ad}>贊助・</span>
                      <img src={vectorEarth} width={10} height={10} alt='' />
                    </div>
                  </div>
                </div>
                <div className={styles.content}>
                  <pre>
                    {renderText()}
                    {outboundInfo.adContent?.split('\n').length > 3 && (
                      <span className={styles.more} onClick={toggleExpand}>
                        {isExpanded ? '' : '.......顯示更多'}
                      </span>
                    )}
                  </pre>
                </div>

                <div className={styles.product_container}>
                  <div className={styles.product_list}>
                    <div className={styles.product_item}>
                      <div className={styles.product_item_container}>
                        <div className={styles.product_item_img_container}>
                          <div className={styles.product_item_img}>
                            <img
                              src={productImage}
                              width={105}
                              height={105}
                              alt=''
                            />
                            <span>您所選品牌下的momo商品圖片</span>
                          </div>
                        </div>
                        <div className={styles.product_item_content}>
                          <div className={styles.product_item_info}>
                            <div className={styles.product_item_title}>
                              momo商品名稱
                            </div>
                            <div className={styles.product_item_description}>
                              momo商品描述
                            </div>
                          </div>
                          <div className={styles.product_item_link}>
                            來去逛逛
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={styles.product_item}>
                      <div className={styles.product_item_container}>
                        <div className={styles.product_item_img_container}>
                          <div className={styles.product_item_img}>
                            <img
                              src={productImage}
                              width={105}
                              height={105}
                              alt=''
                            />
                            <span>您所選品牌下的momo商品圖片</span>
                          </div>
                        </div>
                        <div className={styles.product_item_content}>
                          <div className={styles.product_item_info}>
                            <div className={styles.product_item_title}>
                              momo商品名稱
                            </div>
                            <div className={styles.product_item_description}>
                              momo商品描述
                            </div>
                          </div>
                          <div className={styles.product_item_link}>
                            來去逛逛
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.like}>
                  <img src={vector} alt='' />
                  <span>777</span>
                </div>
                <div className={styles.footer}>
                  <div className={styles.footer_item}>
                    <img src={thumbsUp} width={20} height={20} alt='' />
                    <span>讚</span>
                  </div>
                  <div className={styles.footer_item}>
                    <img src={messageCircle} width={20} height={20} alt='' />
                    <span>留言</span>
                  </div>
                  <div className={styles.footer_item}>
                    <img src={vectorCicle} width={20} height={20} alt='' />
                    <span>分享</span>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.bg_phone} />
            <div className={styles.notice}>
              <InfoOutlineIcon width={13} height={13} />
              廣告的顯示和互動方式可能會因裝置、格式和其他因素而不同
            </div>
          </div> */}
          <div
            className={`${styles['phone-preview']} ${isPreviewExpanded ? styles['expanded'] : ''}`}
          >
            <div
              className={`items-center rounded-lg bg-[#F7F7FA] p-2 text-xs ${styles['adPreviewBtn']} `}
            >
              <div
                className='flex cursor-pointer items-center'
                onClick={togglePreviewExpand}
              >
                <img
                  src={facebookLogo}
                  width={20}
                  height={20}
                  className='mr-2'
                />
                <p className='mr-2'>廣告預覽</p>
                <img
                  src={isPreviewExpanded ? minimize : maximize}
                  width={16}
                  height={16}
                  className='ml-auto cursor-pointer'
                />
              </div>
              {/* 手機預覽畫面 */}
              <div className=''>
                <div className={styles.session_right}>
                  <div className={styles.container}>
                    <div className={styles.phone}>
                      <div className={styles.header}>
                        <img src={fbLogo} width={64} height={37} alt='' />
                        <div className={styles.tools}>
                          <img src={plus} width={19} height={19} alt='' />
                          <img src={search} width={19} height={19} alt='' />
                          <img src={messager} width={19} height={19} alt='' />
                        </div>
                      </div>
                      <div className={styles.header_title_container}>
                        <div className={styles.header_title_logo}>
                          {outboundInfo.logoUrl && (
                            <img
                              src={outboundInfo.logoUrl}
                              id='header-title-logo'
                              width={20}
                              height={20}
                              alt='typescript'
                            />
                          )}
                        </div>
                        <div className={styles.header_title_body}>
                          <span
                            id='header-title-brandName'
                            className={styles.header_title_brandName}
                          >
                            {outboundInfo.name
                              ? outboundInfo.name
                              : '品牌名稱 - momo購物網'}
                          </span>
                          <div>
                            <span className={styles.header_title_ad}>
                              贊助・
                            </span>
                            <img
                              src={vectorEarth}
                              width={10}
                              height={10}
                              alt=''
                            />
                          </div>
                        </div>
                      </div>
                      <div className={styles.content}>
                        <pre>
                          {renderText()}
                          {outboundInfo.adContent?.split('\n').length > 3 && (
                            <span
                              className={styles.more}
                              onClick={toggleExpand}
                            >
                              {isExpanded ? '' : '.......顯示更多'}
                            </span>
                          )}
                        </pre>
                      </div>

                      <div className={styles.product_container}>
                        <div className={styles.product_list}>
                          <div className={styles.product_item}>
                            <div className={styles.product_item_container}>
                              <div
                                className={styles.product_item_img_container}
                              >
                                <div className={styles.product_item_img}>
                                  <img src={clothesImage} alt='' />
                                  <span>您所選品牌下的momo商品圖片</span>
                                </div>
                              </div>
                              <div className={styles.product_item_content}>
                                <div className={styles.product_item_info}>
                                  <div className={styles.product_item_title}>
                                    momo商品名稱
                                  </div>
                                  <div
                                    className={styles.product_item_description}
                                  >
                                    momo商品描述
                                  </div>
                                </div>
                                <div className={styles.product_item_link}>
                                  來去逛逛
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className={styles.product_item}>
                            <div className={styles.product_item_container}>
                              <div
                                className={styles.product_item_img_container}
                              >
                                <div className={styles.product_item_img}>
                                  <img src={clothesImage} alt='' />
                                  <span>您所選品牌下的momo商品圖片</span>
                                </div>
                              </div>
                              <div className={styles.product_item_content}>
                                <div className={styles.product_item_info}>
                                  <div className={styles.product_item_title}>
                                    momo商品名稱
                                  </div>
                                  <div
                                    className={styles.product_item_description}
                                  >
                                    momo商品描述
                                  </div>
                                </div>
                                <div className={styles.product_item_link}>
                                  來去逛逛
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={styles.like}>
                        <img src={vector} width={13} height={13} alt='' />
                        <span>777</span>
                      </div>
                      <div className={styles.footer}>
                        <div className={styles.footer_item}>
                          <img src={thumbsUp} width={10} height={10} alt='' />
                          <span>讚</span>
                        </div>
                        <div className={styles.footer_item}>
                          <img
                            src={messageCircle}
                            width={10}
                            height={10}
                            alt=''
                          />
                          <span>留言</span>
                        </div>
                        <div className={styles.footer_item}>
                          <img
                            src={vectorCicle}
                            width={10}
                            height={10}
                            alt=''
                          />
                          <span>分享</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.bg_phone} />
                  <div className={styles.notice}>
                    <InfoOutlineIcon width={13} height={13} />
                    廣告的顯示和互動方式可能會因裝置、格式和其他因素而不同
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* 版位介紹 */}
          <div
            className={`${isPreviewExpanded ? `${styles['adLinkContainer']} ${styles['expand']}` : 'unExpand'}`}
          >
            <a
              href='https://reurl.cc/LnOvK9'
              className={styles.adLink}
              target='_blank'
              rel='noreferrer'
            >
              <img
                src={instagramLogo}
                width={20}
                height={20}
                className='mr-2'
              />
              版位介紹
              <img src={externalLink} width={16} height={16} className='ml-2' />
            </a>
            <a
              href='https://reurl.cc/NxM5Kq'
              className={styles.adLink}
              target='_blank'
              rel='noreferrer'
            >
              <img src={googleLogo} width={20} height={20} className='mr-2' />
              版位介紹
              <img src={externalLink} width={16} height={16} className='ml-2' />
            </a>
          </div>
        </div>
      </div>
    </CollapseSection>
  );
};

export default Outbound;
